// zh.ts — 중국어(간체) 문구
export const zh = {
      _l: "zh",
      eyebrow: "MolePin 空投 · 免费 MOL",
      h1: '从交易所收到过 BNB？<br><span class="g">免费领取 10,000 MOL。</span>',
      lede: "每笔从交易所到你钱包的入账 = <em>10,000 MOL</em>（最多 10 笔）。<em>关注 X 得 10,000 MOL</em> + <em>Telegram 得 10,000 MOL</em> —— 即使没有入账也能获得 <em>20,000 MOL</em>。每个钱包最多 <em>120,000 MOL</em>。",
      notConnected: "尚未绑定钱包到矿脉",
      exchLabel: "关联矿脉的交易所：",
      fcfsLabel: "已加入的守护者",
      railTitle: "矿脉印记",
      sealDepName: "入账", sealDepDesc: "交易所向你的钱包发送了 BNB（或 BNB 链代币）。每笔 10,000 MOL，最多 10 笔。",
      sealDepBtn: "验证入账",
      proveMore: function (n: number) { return "追加登记 (" + n + "/10)"; },
      proveFull: "已领取全部10笔",
      sealXName: "关注 𝕏", sealXDesc: "在 𝕏 关注 MolePin → 10,000 MOL。仅需一次。",
      sealXBtn: "绑定 𝕏",
      sealTgName: "Telegram", sealTgDesc: '在群组内发送 "MolePin Up" → 10,000 MOL。仅需一次。',
      sealTgBtn: "进入洞穴",
      stLocked: "未封印", stDone: "已封印",
      digTitleLocked: "矿丘仍然紧闭", digSubLocked: "集齐全部三枚印记，破土挖出你的 MOL。",
      digBtnLocked: "印记未集齐",
      digTitleOpen: "矿脉开启", digSubOpen: "三枚印记闪耀金光。破土而出，取回合约所欠于你的。",
      digBtnOpen: "挖掘 MOL",
      modalTitle: "验证你的入账",
      eligibleNote: "⚠️ 仅计入由交易所（Binance、Coinbase…）直接发送到你钱包且<b>不低于 0.001 BNB</b> 的入账。来自个人钱包、DEX 或他人的转账不符合条件。",
      modeScan: "自动扫描", modeTx: "输入 txid",
      scanHint: function (ex: string) { return "扫描你的钱包中来自 " + ex + " 的 BNB 入账。"; },
      scanBtn: "查找我的入账",
      txHint: "粘贴最多 10 个 BNB 入账交易哈希，每行一个。",
      txGuideTitle: "📖 如何找到交易哈希",
      txGuideHint: "在 BscScan 打开你钱包的交易记录。找到 From 为交易所（Binance 等）且带绿色 IN 标记的一行，复制该 Transaction Hash。",
      tryTxidTitle: "自动找不到？",
      tryTxidBody: "你交易所的热钱包可能还不在我们的列表中。你可以直接粘贴入账的交易哈希 —— 打开 BscScan，找到交易所入账（绿色 IN），复制其哈希。",
      tryTxidBtn: "手动输入交易哈希",
      verifyTxBtn: "验证 txid",
      claimBtn: "挖掘 MOL",
      loreTitle: "矿脉",
      loreBody: "<strong>Eldorasia</strong>，十七个黄金鼹鼠部族的地下王国。十六族消失之后，最后的继承者 —— <strong>MolePin</strong> —— 重新开凿。一位 <strong>守护者（Dener）</strong> 立于其侧，守护矿脉。印记，是矿脉辨认你真实身份的方式。",
      trust: "这是一个独立的 MolePin 社区活动，与任何交易所无关。资格仅依据公开的链上数据。签名仅用于证明钱包所有权；绝不会请求任何转账或授权。此处内容均非投资建议。",
      dexMsg: "<b>为你的钱包命名</b> —— 用可读名称替代 0x。DEXignation 已上线。",
      dexCta: "创建名称",
      linksTitle: "矿脉之门与盟友",
      linksSub: "打开交易所转移 BNB，或访问我们的盟友领域。",
      linksExch: "交易所",
      linksPartner: "盟友站点",
      linksCommunity: "社区",
      linksChannelTag: "频道 · 资讯",
      linksGroupTag: "群组 · 赚取印记",
      linksDigmolTag: "守护者 / 分销商",
      linksDexTag: "合作伙伴",
      inappMsg: "钱包无法在此应用内浏览器中使用。请在浏览器中打开以继续。",
      inappBtn: "在浏览器中打开",
      inappManual: "点击 ⋯ 菜单 → \"在外部浏览器打开\"。",
      // dynamic
      sealCount: function (n: number) { return n + " / 3"; },
      validCount: function (n: number) { return "已验证 " + n + " 笔入账"; },
      depositsFound: function (n: number, bnb?: string) { return "入账 " + n + " 笔" + (bnb ? " (" + bnb + " BNB)" : "") + " 确认 ✓"; },
      willGetMol: function (m: string) { return "→ 你将获得 " + m + " MOL"; },
      noDepositsBig: "BNB 入账 0 笔",
      alreadyClaimed: "已领取",
      alreadyClaimedBig: "已领取的入账",
      alreadyClaimedNote: "这些入账已用于领取",
      myTxTitle: "已登记的入账",
      myTxConfirmed: "已领取",
      myTxPending: "处理中",
      noValid: "未找到符合条件的交易所入账",
      claimAmt: function (m: string) { return "挖掘 " + m + " MOL"; },
      noGas: "领取需要少量 BNB 作为手续费。请充值一些 BNB 后重试。",
      errTxidUsed: "此入账已被领取。",
      errBadSigner: "签名错误，请刷新后重试。",
      errExpired: "请求已过期，请重试。",
      errWalletCap: "此钱包已达到领取上限（10笔）。",
      errClaimerLimit: "空投已结束（先到先得10,000名）。",
      errPaused: "领取暂时暂停。",
      errNothing: "没有可领取的内容。",
      errTransferFail: "代币转账失败，请稍后再试。",
      dug: function (m: string) { return "你挖到了黄金 —— " + m + " MOL 已归你所有。"; },
      needConnect: "请先绑定钱包到矿脉。",
      overLimit: "最多 10 个 txid。",
      fcfsClosed: "已满", fcfsRemaining: function (r: number) { return "剩余 " + r + " 个名额"; }, fcfsMax: "名额已满",
      errClosed: "全部 10,000 个守护者名额已被占满。",
      errCap: "此钱包已挖满 10 笔。",
      xBound: function (h: string) { return "𝕏 已绑定：@" + h; },
      tgHelp: "1. 加入群组  2. 发送 \"MolePin Up\" 或 \"MolePin 화이팅\"  3. 完成。",
      openTg: "打开 Telegram", copyPhrase: "复制 \"MolePin Up\"", phraseCopied: "已复制！",
      errNoMM: "需要 MetaMask。", errNoCB: "需要 Coinbase Wallet。", cancelled: "已取消。",
      connTimeout: "MetaMask 无响应，请重新尝试连接。",
      connecting: "正在连接 MetaMask… 请在应用中确认后返回。",
      cancel: "取消",
      copyAddr: "点击复制完整地址", copied: "✓ 已复制！",
      disconnect: "断开连接",
      donateTitle: "捐赠",
      donateNote: "以太坊 · BNB 链 · Polygon",
      donateWarn: "请仅使用上述网络转账。使用其他网络可能导致资产永久丢失。",
      donateCopied: "地址已复制",
      wrongChainWarn: "网络不匹配。请切换到 BNB Smart Chain。",
      switchChainBtn: "切换网络",
      wrongChainAlert: "请切换到 BNB Smart Chain 网络。",
      wrongChainRejected: "需要切换网络才能挖取 MOL。",
      bonusClaim: "领取 10,000 MOL",
      bonusClaiming: "正在请求签名…",
      bonusPending: "处理中…",
      bonusReceived: "✓ 已领取",
      bonusDone: "已获得 10,000 MOL！",
      bonusAlready: "已经领取过了。",
      bonusNeedSeal: "请先获得印章。",
      bonusCapReached: "已达到领取上限。",
      xErrDup: "此 𝕏 账号已在其他钱包领取过印章。一个 X 账号只能绑定一个钱包。",
      xErrFollow: "无法验证关注状态。请在 𝕏 关注 MolePin 后重试。",
      xErrGeneric: "𝕏 认证失败，请稍后重试。",
      rsnBelowMin: "金额需至少 0.001 BNB",
      rsnNotExchange: "并非来自交易所的转账",
      rsnRecipient: "并非转入你已连接的钱包",
      rsnNotFound: "找不到该交易",
      rsnNotConfirmed: "交易尚未确认",
      rsnUnknown: "不符合条件的入账",
};
export default zh;